<template>
    <v-container fluid>
        <v-row dense>
            <v-col>
                <v-card class="pa-1">
                    <Title title="観察項目" dense />
                    <v-simple-table><!-- <v-simple-table fixed-header height="200"> -->
                        <thead>
                            <tr>
                                <th>項目</th>
                                <th>値</th>
                                <th width="64"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="observateItemValue in observateItemValues" :key="observateItemValue.id" @click="onSelectedObservateValue(observateItemValue)">
                                <td>{{observateItem(observateItemValue.id).name}}</td>
                                <td>
                                    <div v-if="observateItemValue.value == null || observateItemValue.value == ''" class="warning--text">未観察</div>
                                    <div v-else v-html="value(observateItemValue)"/>
                                </td>
                                <td>
                                    <v-btn 
                                        v-if="!observateItem(observateItemValue.id).isRequired" 
                                        @click="onClickDeleteValue(observateItemValue)" 
                                        color="warning"                                          
                                        small 
                                        icon
                                        elevation="0">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card v-if="!readOnly">
                    <v-container fluid>
                        <v-row dense>
                            <v-col v-if="observateItems.length > 0">
                                <v-select 
                                    dense 
                                    v-model="observateItemValue.item" 
                                    label="観察項目名" 
                                    outlined 
                                    :items="selectorItems" 
                                    item-text="name"
                                    item-value="id"
                                    return-object 
                                    @change="onSelectedObservateItem" />
                            </v-col>
                            <v-col v-if="selectorItemType == 'new'">
                                <v-text-field dense v-model="observateItemValue.name" clearable label="新規観察項目名" item-text="text" outlined />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-if="valueType == 'text'"                                           
                                    dense 
                                    v-model="observateItemValue.value" 
                                    clearable 
                                    label="観察値" 
                                    item-text="text" 
                                    outlined
                                    :suffix="valueUnit"
                                        />
                                <v-text-field
                                    v-else-if="valueType == 'number'"                                           
                                    dense 
                                    v-model="observateItemValue.value" 
                                    clearable 
                                    label="観察値" 
                                    item-text="text" 
                                    outlined
                                    :suffix="valueUnit"
                                        />
                                <v-select 
                                    v-else-if="valueType == 'selector'"
                                    v-model="observateItemValue.value"
                                    clearable
                                    label="観察値"
                                    outlined
                                    :items="observateItemValue.item.data.values"
                                    dense
                                    item-text="text"
                                    item-value="value"/>
                                <SugarContentV 
                                    v-else-if="valueType == 'sugar_v'"
                                    v-model="observateItemValue.value"
                                    />
                                <SugarContentH
                                    v-else-if="valueType == 'sugar_h'"
                                    v-model="observateItemValue.value"
                                    />
                            </v-col>
                        </v-row>
                        <v-btn class="ma-1" color="primary" @click="onClickAddValue" depressed :disabled="selectorItemType == 'none' || selectorItemType == 'change'">
                            <v-icon>mdi-plus-circle</v-icon>追加
                        </v-btn>
                        <v-btn class="ma-1" color="primary" @click="onClickUpdateValue" depressed :disabled="selectorItemType == 'none' || selectorItemType != 'change'">
                            <v-icon>mdi-pencil-outline</v-icon>変更
                        </v-btn>
                    </v-container>
                    <!-- <v-card class="ml-1 mr-1 mb-1" style="margin-top:-20px" outlined>
                        <div class="ma-2">
                            <v-btn class="ma-1" color="primary" @click="onClickAddValue" depressed><v-icon>mdi-plus-circle</v-icon>追加</v-btn>
                            <v-btn class="ma-1" color="primary" @click="onClickUpdateValue" depressed><v-icon>mdi-pencil-outline</v-icon>変更</v-btn>
                        </div>
                    </v-card> -->
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import SugarContentV from '@/components/seedling/items/ObservateSugarContentV';
    import SugarContentH from '@/components/seedling/items/ObservateSugarContentH';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            Title,
            SugarContentV,
            SugarContentH,
            Confirm
        },
        props: {
            readOnly: {
                type: Boolean,
                default: false
            },
            observateItemValues: Array,
            observateItems: Array,
            target: Number                    // 対象(1:苗, 2:収穫物)
        },
        data: function () {
            return {
                selectorItemType: 'none',
                // 選択された観察項目とその値
                observateItemValue: {
                    item: null,
                    name: "",
                    value: null
                },
            }
        },
        computed: {
            // ===============================
            // 選択可能な観察項目
            selectorItems: function () {
                const self = this
                const items = []
                items.push({
                    id: 0,
                    name: "新しい観察項目"
                })
                for (var i=0; i<this.observateItems.length; i++) {
                    const observateItem = this.observateItems[i]
                    // if (this.observateItemValues.findIndex((v)=>v.id == observateItem.id) < 0 && (observateItem.target == 0 || observateItem.target == self.target)) {
                    //     items.push(observateItem)
                    // }
                    if (observateItem.target == 0 || observateItem.target == self.target) {
                        items.push(observateItem)
                    }
                }
                return items
            },
            // ===============================
            // 観察値の単位
            valueUnit: function () {
                if (this.observateItemValue.item != null) {
                    return this.observateItemValue.item.unit
                }
                return ""
            },
            // ===============================
            // 観察値の種類
            valueType: function () {
                if (this.observateItemValue.item == null) {
                    return "text"
                }
                switch (this.observateItemValue.item.id) {
                    case 1:     // 1果重
                        return "number"
                    case 10:    // サイズ
                        return "selector"
                    case 20:    // 糖度
                        return "number"
                    case 21:    // 糖度(垂直)
                        return "sugar_v"
                    case 22:    // 糖度(水平)
                        return "sugar_h"
                    default:
                        return "text"
                }
            },
            // ===============================
            // 一覧に表示する観察値
            value: function () {
                const self = this
                return function(observateItemValue) {

                    // if (observateItemValue.value == null || observateItemValue.value == "") {
                    //     return "未観察"
                    // }

                    const observateItem = self.observateItem(observateItemValue.id)
                    
                    switch (observateItemValue.id) {
                        case 10:    // サイズ
                            const valueIndex = observateItem.data.values.findIndex((v)=>v.value === observateItemValue.value)
                            return observateItem.data.values[valueIndex].text
                        case 21:    // 糖度(垂直)
                            return "上 : "+observateItemValue.value.top+"%<br/>中央 : "+observateItemValue.value.center+"%<br/>下 : "+observateItemValue.value.bottom+"%"
                        case 22:    // 糖度(水平)
                            var text = ""
                            for (var i=0; i<observateItemValue.value.length; i++) {
                                const v = observateItemValue.value[i]
                                text += ("P"+(i+1)+" : "+v+"%")
                                if (i < observateItemValue.value.length - 1) {
                                    text += "<br/>"
                                }
                            }
                            return text
                        default:
                            return observateItemValue.value + observateItem.unit
                    }
                }
            }
        },
        methods: {
            // ============================================
            // 観察項目名選択時
            onSelectedObservateItem: function () {
                if (this.observateItemValue.item.id == 0) {
                    this.selectorItemType = "new"
                    return
                }
                const valueIndex = this.observateItemValues.findIndex((v)=>v.id == this.observateItemValue.item.id)
                if (valueIndex >= 0) {
                    const value = this.observateItemValues[valueIndex]
                    this.selectorItemType = "change"
                    this.observateItemValue.item = this.observateItem(value.id)
                    this.observateItemValue.name = ""
                    this.observateItemValue.value = value.value
                } else {
                    this.selectorItemType = "add"
                    this.observateItemValue.value = null
                }
            },
            // // ============================================
            // // 観察項目名のクリアボタン押下時
            // onClearObservateItem: function () {
            //     console.log("onClearObservateItem")
            //     this.selectorItemType = "none"
            //     this.observateItemValue.item = null
            //     this.observateItemValue.name = ""
            //     this.observateItemValue.value = null
            // },
            // ============================================
            // 観察値一覧の行選択時
            onSelectedObservateValue: function (item) {
                this.selectorItemType = "change"
                this.observateItemValue.item = this.observateItem(item.id)
                this.observateItemValue.name = ""
                this.observateItemValue.value = item.value
            },
            // ============================================
            // 追加ボタン押下時
            onClickAddValue: function () {
                const userUID = this.$store.getters["userUID"]

                if (this.observateItemValue.item.id == 0) {

                    // =================================
                    // 新しい観察項目の時は、新規に追加
                    var newID = 101
                    if (this.observateItems.length > 0) {
                        newID = Math.max(...this.observateItems.map(m => m.id)) + 1
                    }
                    if (newID < 101) {
                        newID = 101
                    }
                    const item = {
                        version: "1.0.0",
                        id: newID,
                        order: newID,
                        name: this.observateItemValue.name,
                        target: this.target,
                        unit: "",
                        data: null,
                        isSystemTemplate: false,
                        register: {
                            userUID: userUID,
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        }
                    }
                    this.observateItems.push(item)
                    this.observateItemValue.item = item

                    this.registNewObservateItem(item)
                }
                const value = {
                    id: this.observateItemValue.item.id,
                    value: this.observateItemValue.value,
                }
                switch (this.observateItemValue.item.id) {
                    case 1:     // 1果重
                        value.value *= 1
                    case 20:    // 糖度
                        value.value *= 1
                }

                // =================================
                // 観察値の一覧に追加
                this.observateItemValues.push(value)

                // =================================
                // 編集項目をクリア
                this.observateItemValue = {
                    item: null,
                    name: "",
                    value: null
                }
            },
            // ============================================
            // 変更ボタン押下時
            onClickUpdateValue: function () {
                const index = this.observateItemValues.findIndex((v)=>v.id === this.observateItemValue.item.id)
                this.observateItemValues[index].value = this.observateItemValue.value
            },
            // ============================================
            // 観察値一覧の行の削除ボタン押下時
            onClickDeleteValue: function (observateItemValue) {
                const self = this
                this.$refs.confirm.show({
                    title: "削除",
                    message: "この観察値を削除して宜しいですか？<br/>※削除後、保存すると元には戻せません。",
                    width: 400,
                    icon: "mdi-alert",
                    buttonYes: "削除する",
                    buttonNo: "しない",
                    listenerYes: function () {
                        const index = self.observateItemValues.findIndex((v)=>v.id === observateItemValue.id)
                        self.observateItemValues.splice(index, 1)
                        return true
                    },
                })
            },
            observateItem: function (id) {
                const index = this.observateItems.findIndex((v)=>v.id === id)
                return this.observateItems[index]
            },
            registNewObservateItem: function (newItem) {
                const self = this
                const userUID = this.$store.getters["userUID"]
                db.collection("users").doc(userUID).collection("managements").doc("observate").collection("observate_items").doc(""+newItem.id).set(newItem).then(function(){
                    self.$store.commit("notification", {message:"新しい観察項目を登録しました。"})
                }).catch (function(error){
                    self.$store.commit("notification", {message:"観察項目の登録に失敗しました。", isError:true})
                })
            },
        }
    }
</script>
